import React from 'react';
import clsx from 'clsx';
import css from './Image.module.css';

export interface ImageExtendedProps {
  alternateText?: string;
  showTooltip?: boolean;
  height: number;
  width: number;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
}

export interface ImageProps extends ImageExtendedProps {
  source: string;
  alternateText: string;
}

const Image: React.FC<ImageProps> = (props: ImageProps) => {
  const {
    source,
    alternateText,
    height,
    width,
    showTooltip = true,
    disabled = false,
  } = props;

  const onClickImage = (
    event: React.MouseEvent<HTMLImageElement, MouseEvent>
  ) => {
    if (props.onClick && !disabled) {
      event.preventDefault();
      event.stopPropagation();
      props.onClick();
    }
  };

  return (
    <img
      className={clsx(
        props.className,
        props.onClick && !disabled && css.clickable
      )}
      src={source}
      alt={alternateText}
      height={height}
      width={width}
      onClick={onClickImage}
      title={showTooltip ? props.alternateText : ''}
    />
  );
};

export default Image;
